module.exports = __webpack_public_path__ + "img/dashboard-active.1242bebb.svg";